import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './PaymentRequest.scss';
import { Heading } from '@/components/Elements/Heading';
import { Button } from '@/components/Elements';
import { Event, LineItem, CashPaymentOption, PaymentDetails } from '../types';
import { ReactComponent as EditIcon } from '@/assets/img/edit-icon-new-v2-red.svg';
import { BookAppointmentDTO, useRequestPayment, useUpdateAppoinment } from '../api/requestPayment';
import petimg from '@/assets/img/user-default-icon.png';
import CardIcon from '@/assets/img/icon-card.svg';
import Utils from '@/utils/util';
import PetCat from '@/assets/img/pet-cat-default.svg';
import PetsIcon from '@/assets/img/profile-pic.svg';
import { ReactComponent as CopyIconStyle } from '@/assets/img/new-copy-style.svg';
import { ReactComponent as LinkCopy } from '@/assets/img/link-copy-sucess.svg';
import { ReactComponent as MenuBackIcon } from '@/assets/img/menu-back-icon.svg';
import { UserContext } from '@/routes';
import { useAuth } from '@/lib/auth';
import { showNotification } from '@/utils/notificationUtils';
import BoardingPetInfo from '@/features/petAttributes/components/BoardingPetInfo';
import { PetConfirmationDisplay } from '@/features/availability/components/PetConfirmationDisplay';
import { useTranslation } from 'react-i18next';

import { MakePaymentStripe } from './MakePaymentStripe';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { MakePaymentSquare } from './MakePaymentSquare';
import { CreditCard } from '@/features/billing/api/addCreditCard';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';
import { formatValue } from 'react-currency-input-field';

type RequestPaymentProps = {
  open: boolean;
  onClose: (refresh: boolean) => void;
  onConfirm?: (showPRSuccessModal: boolean) => void;
  selectedAppointment: Event;
  isMap?: boolean;
};
const PaymentRequest = ({
  open,
  onClose,
  onConfirm,
  selectedAppointment,
  isMap,
}: RequestPaymentProps) => {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY as string);

  const PAYMENT_TYPES = {
    SUCCESS: ['succeeded', 'paid', 'requires_capture', 'completed', 'APPROVED', 'COMPLETED'],
    FAILURE: ['failure', 'CANCELED', 'FAILED'],
  };

  const PAYMENT_STATUS = {
    PAYMENT_REQUESTED: 'Payment requested',
    PAYMENT_COMPLETED: 'Payment completed',
    REQUEST_PAYMENT: 'Request payment',
    REFUND_PAYMENT: 'Refund',
  };

  const userContext = useContext(UserContext);
  const { user } = useAuth();
  const currency = businessCurrency(user, 'USD');
  const { t, i18n } = useTranslation();
  const requestPaymentMutation = useRequestPayment();
  const updateAppointmentMutation = useUpdateAppoinment();

  const [otherCharges, setOtherCharges] = useState<any>(
    selectedAppointment.othCharges ? selectedAppointment.othCharges : 0
  );
  const [showMore, setShowMore] = useState(false);
  const [lineItem, setLineItem] = useState<LineItem>();
  const [editOtherCharges, setEditOtherCharges] = useState(false);
  const [storeDiscount, setStoreDiscount] = useState<any>(0);
  const [newStoreDiscount, setNewStoreDiscount] = useState<string | number>();
  const [newOtherCharges, setNewOtherCharges] = useState<string | number>();
  const [otherChargesNote, setOtherChargesNote] = useState<string | number>();

  const [editDiscount, setEditDiscount] = useState(false);
  const [tax, setTax] = useState(false);
  const [texAmount, setTaxAmount] = useState<any>(0);
  const [newTaxAmount, setNewTaxAmount] = useState<string | number>();
  const [reloadEvents, setReloadEvents] = useState(false);
  const [showCashPayment, setShowCashPayment] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState<PaymentDetails>();
  const [tippingCharges, setTippingCharges] = useState<any>(
    selectedAppointment.serviceTip ? selectedAppointment.serviceTip : 0
  );
  const [editTippingCharges, setEditTippingCharges] = useState(false);
  const [isCopyLocation, setIsCopyLocation] = useState(false);
  let timer: any;
  useEffect(() => {
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    Utils.scrollToTop();
    updateLineItem(selectedAppointment);
  }, []);

  const updateLineItem = (data: Event | LineItem) => {
    const lineItem: LineItem = {
      subTotal: data.subTotal ? data.subTotal : 0,
      othCharges: data.othCharges ? data.othCharges : 0,
      chargeNotes: data.chargeNotes ? data.chargeNotes : '',
      storeDisc: data.storeDisc ? data.storeDisc : 0,
      total: data.total ? data.total : 0,
      advPayment: data.advPayment ? data.advPayment : 0,
      serviceTip: data.serviceTip ? data.serviceTip : 0,
      tax: data.tax ? Number(data.tax) : 0,
    };
    setTippingCharges(data.serviceTip ? data.serviceTip.toString() : 0);
    setNewStoreDiscount(data.storeDisc ? data.storeDisc : 0);
    setNewOtherCharges(data.othCharges ? data.othCharges : 0);
    setOtherChargesNote(data.chargeNotes ? data.chargeNotes : '');
    setTaxAmount(data.tax ? data.tax : 0)
    setLineItem(lineItem);
  };

  const getPaymentStatus = () => {
    const orderArray =
      selectedAppointment?.orders && selectedAppointment?.orders.length > 0
        ? selectedAppointment?.orders
        : [];
    for (const order of orderArray) {
      if (!order.isAdvancePayment) {
        if (order.paymentStatus === null) {
          return PAYMENT_STATUS.PAYMENT_REQUESTED;
        } else if (order.paymentStatus !== null) {
          if (PAYMENT_TYPES.FAILURE.indexOf(order.paymentStatus || '') >= 0) {
            return PAYMENT_STATUS.REQUEST_PAYMENT;
          }
          if (PAYMENT_TYPES.SUCCESS.indexOf(order.paymentStatus || '') >= 0) {
            return PAYMENT_STATUS.PAYMENT_COMPLETED;
          }
        } else {
          // if (currentBalanceAmount < 0) {
          //   return 'Refund Amount';
          // }
          return PAYMENT_STATUS.REQUEST_PAYMENT;
        }
      }
    }
    if (Number(lineItem?.total) < 0) {
      return PAYMENT_STATUS.REFUND_PAYMENT;
    }
    return PAYMENT_STATUS.REQUEST_PAYMENT;
  };
  const applyOtherCharges = async () => {
    if (newOtherCharges === undefined || parseFloat(newOtherCharges as string) < 0) {
      showNotification({ type: 'warning', title: 'Please enter valid data for other charges.' });
      return;
    }
    const res = await updateAppointmentMutation.mutateAsync({
      id: Number(selectedAppointment?.id),
      otherCharges: newOtherCharges ? Number(newOtherCharges) : 0,
      storeDiscount: newStoreDiscount ? Number(newStoreDiscount) : 0,
      chargeNotes: otherChargesNote ? String(otherChargesNote) : '',
      roomId: selectedAppointment.room ? selectedAppointment.room.id : undefined,
      serviceTip: tippingCharges ? Number(tippingCharges) : 0,
      tax: newTaxAmount ? Number(newTaxAmount) : 0,
    });
    updateLineItem(res);
    setEditDiscount(false);
    setEditOtherCharges(false);
    setReloadEvents(true);
  };

  const applyTippingCharges = async () => {
    if (tippingCharges === undefined || parseFloat(tippingCharges as string) < 0) {
      showNotification({ type: 'warning', title: 'Please enter valid data for tips.' });
      return;
    }
    const res = await updateAppointmentMutation.mutateAsync({
      id: Number(selectedAppointment?.id),
      otherCharges: newOtherCharges ? Number(newOtherCharges) : 0,
      chargeNotes: otherChargesNote ? String(otherChargesNote) : '',
      storeDiscount: newStoreDiscount ? Number(newStoreDiscount) : 0,
      roomId: selectedAppointment.room ? selectedAppointment.room.id : undefined,
      serviceTip: tippingCharges ? Number(tippingCharges) : 0,
      tax: newTaxAmount ? Number(newTaxAmount) : 0,
    });
    updateLineItem(res);
    setEditTippingCharges(false);
    setReloadEvents(true);
  };
  const applyStoreDiscount = async () => {
    if (newStoreDiscount === undefined || parseFloat(newStoreDiscount as string) < 0) {
      showNotification({ type: 'warning', title: 'Please enter valid data for store discount.' });
      return;
    }
    if (lineItem?.total && parseFloat(newStoreDiscount as string) > lineItem?.total) {
      showNotification({
        type: 'warning',
        title: 'Store discount should not be greater than total payable.',
      });
      return;
    }
    const res = await updateAppointmentMutation.mutateAsync({
      id: Number(selectedAppointment?.id),
      otherCharges: newOtherCharges ? Number(newOtherCharges) : 0,
      chargeNotes: otherChargesNote ? String(otherChargesNote) : '',
      storeDiscount: newStoreDiscount ? Number(newStoreDiscount) : 0,
      roomId: selectedAppointment.room ? selectedAppointment.room.id : undefined,
      serviceTip: tippingCharges ? Number(tippingCharges) : 0,
      tax: newTaxAmount ? Number(newTaxAmount) : 0,
    });
    updateLineItem(res);
    setEditDiscount(false);
    setEditOtherCharges(false);
    setReloadEvents(true);
  };

  const applyTax = async () => {
    if (newTaxAmount === undefined || parseFloat(newTaxAmount as string) < 0) {
      showNotification({ type: 'warning', title: 'Please enter valid data for tax.' });
      return;
    }
    const res = await updateAppointmentMutation.mutateAsync({
      id: Number(selectedAppointment?.id),
      otherCharges: newOtherCharges ? Number(newOtherCharges) : 0,
      chargeNotes: otherChargesNote ? String(otherChargesNote) : '',
      storeDiscount: newStoreDiscount ? Number(newStoreDiscount) : 0,
      roomId: selectedAppointment.room ? selectedAppointment.room.id : undefined,
      serviceTip: tippingCharges ? Number(tippingCharges) : 0,
      tax: newTaxAmount ? Number(newTaxAmount) : 0,
    });
    updateLineItem(res);
    setEditDiscount(false);
    setEditOtherCharges(false);
    setReloadEvents(true);
    setTax(false);
  };
  const paymentStatus = getPaymentStatus();

  const updateAppointmentPayment = async (data?: PaymentDetails, skipPd = false) => {
    const pd = data ? data : paymentDetails;
    if (showCashPayment && (!pd || !pd?.data)) {
      showNotification({
        type: 'error',
        title: t('Please select payment mode to complete the payment.'),
      });
      return;
    }
    if (!requestPaymentMutation.isLoading) {
      // if (selectedPrice) {
      const isRefund = paymentStatus.toLowerCase() === PAYMENT_STATUS.REFUND_PAYMENT.toLowerCase();
      const request: BookAppointmentDTO = {
        id: Number(selectedAppointment?.id),
        amount: Number(lineItem?.total),
        otherCharges: Number(lineItem?.othCharges),
        storeDiscount: Number(lineItem?.storeDisc),
        chargeNotes: lineItem?.chargeNotes,
        serviceTip: tippingCharges ? Number(tippingCharges) : 0,
        isRefund: isRefund,
        roomId: selectedAppointment.room ? selectedAppointment.room.id : undefined,
        paymentType: pd ? pd.type : undefined,
        tax: Number(lineItem?.tax)
      };
      if (showCashPayment) {
        if (pd?.isNewCard) {
          request.cardDetails = { paymentMethodId: (pd?.data as CreditCard).id };
        } else {
          if (pd?.type === 'card') {
            request.cardId = pd.data ? (pd?.data as CreditCard)?.id : undefined;
          } else {
            request.paymentProvider = pd?.data ? (pd.data as CashPaymentOption).name : '';
          }
        }
        if (pd?.verificationToken) request.verificationToken = pd?.verificationToken;
      }
      await requestPaymentMutation.mutateAsync(request);
      onConfirm && onConfirm(isRefund || showCashPayment ? false : true);
    }
  };

  const onCashPaymentClick = () => {
    setShowCashPayment(true);
  };
  const backToPaymentRequest = () => {
    setShowCashPayment(false);
    setPaymentDetails(undefined);
    Utils.scrollToTop();
  };
  const onPaymentDetailsChange = (pd: PaymentDetails) => {
    setPaymentDetails(pd);
  };

  const downloadPDF = () => {
    try {
      // Prepare service items HTML
      const serviceName = selectedAppointment.room
        ? selectedAppointment.room.name
        : selectedAppointment.service?.name || 'Service';
      const servicePrice = selectedAppointment.room
        ? selectedAppointment.bookingFee
        : selectedAppointment.servicePrice;

      let serviceItemsHtml = `
        <div class="service-detailss" >
        <div class="service-item" >
          <span class="service-name">${serviceName}</span>
          <span class="service-price">${currency}${Utils.formatAmount(servicePrice)}</span>
        </div>
         <div class="service-desc">${selectedAppointment?.service?.description}</div>
         </div>
      `;

      // Add addon services if any
      if (selectedAppointment.addonServices?.length > 0) {
        selectedAppointment.addonServices.forEach(addon => {
          serviceItemsHtml += `
            <div class="service-item">
              <span class="service-name">${addon.name}</span>
              <span class="service-price">${currency}${Utils.formatAmount(addon.price || 0)}</span>
            </div>
          `;
        });
      }

      const template = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Payment Receipt - ${selectedAppointment.id}</title>
            <style>
                * { margin: 0; padding: 0; box-sizing: border-box; }
                body { font-family: 'Arial', sans-serif; line-height: 1.6; color: #333; background: #fff; padding: 20px; }
                .receipt-container { max-width: 800px; margin: 0 auto; background: #fff; border: 1px solid #ddd; border-radius: 8px; overflow: hidden; }
                .header { padding: 20px;padding-bottom:0px; padding-left:20px; display:flex ;justify-content: space-between;}
                 .business-details { padding-left:10px}
                 .business-title{ color: #333 !important; font-size: 24px; font-weight: bold;}
                 .business-address{ color: #333 !important; opacity: 0.9;}
                .logo { font-size: 32px; font-weight: bold; letter-spacing: 2px; }
                .header-subtitle { font-size: 18px; opacity: 0.9; }
                .receipt-content { padding: 30px; padding-bottom:10px }
                .receipt-title { font-size: 24px; font-weight: bold; margin-bottom: 20px; color: #333; border-bottom: 2px solid #F85663; padding-bottom: 10px; }
                .customer-info { display: flex; justify-content: space-between; margin-bottom: 10px; padding: 20px; background: #f8f9fa; border-radius: 8px; }
                .customer-details h3 { color: #F85663; margin-bottom: 10px; }
                 .appointment-details h3 { color: #F85663; margin-bottom: 10px; }
                .service-details {  padding: 20px; padding-top:10px; padding-bottom:10px; border-radius: 8px; }
                .service-item { display: flex; justify-content: space-between; padding-bottom :5px; }
                .service-detailss { border-bottom: 1px solid #eee;}
                .service-item:last-child { border-bottom: none; }
                .service-name { font-weight: 500; }
                .service-price { font-weight: bold; }
                .payment-summary { background: #f8f9fa; padding: 20px; border-radius: 8px; }
                .service-desc {margin-bottom:10px}
                .summary-row { display: flex; justify-content: space-between; padding: 8px 0 0 0; }
                .summary-row.total { border-top: 2px solid #F85663; margin-top: 5px; padding-top: 5px; font-size: 18px; font-weight: bold; color: #333; }
                .footer { text-align: center; padding: 20px; background: #f8f9fa; color: #666; font-size: 14px; }
                @media print { body { padding: 0; } .receipt-container { border: none; border-radius: 0; } }
            </style>
        </head>
        <body>
            <div class="receipt-container">
                <div class="header">

           <div class="business-details">
           <div class="business-title">${selectedAppointment?.businessLocation?.name}</div>
           <div class="business-address">${selectedAppointment?.businessLocation?.address}</div>
           </div>
           <div class="logo"> <img
             style="width: 160px; height: 36px; top: 8px; left: 0"
             src="/app/static/media/p-logo.05f3bfd9.svg"
           /></div>
                </div>
                
                <div class="receipt-content">
                    <div class="receipt-title">Payment Receipt</div>
                    
                    <div class="customer-info">
                        <div class="customer-details">
                            <h3>Customer Information</h3>
                            <p><strong>Name:</strong> ${selectedAppointment.petParent?.name || 'N/A'}</p>
                            <p><strong>Email:</strong> ${selectedAppointment.petParent?.email || 'N/A'}</p>
                            <p><strong>Phone:</strong> ${Utils.formatPhoneNumber(selectedAppointment.petParent?.phone) || 'N/A'}</p>
                        </div>
                        <div class="appointment-details">
                            <h3>Appointment Details</h3>
                            <p><strong>ID:</strong> ${selectedAppointment.id?.toString() || 'N/A'}</p>
                            <p><strong>Date:</strong> ${Utils.formatDateStringTz(selectedAppointment.startTime, user?.activeLocation?.timezone, 'ddd, DD MMM, yyyy')}</p>
                            <p><strong>Time:</strong> ${Utils.formatDateStringTz(selectedAppointment.startTime, user?.activeLocation?.timezone, 'hh:mm A')}</p>
                        </div>
                    </div>
                    
                    <div class="service-details">
                        <h3 style="color: #F85663;">Services</h3>
                        ${serviceItemsHtml}
                       
                    </div>
                    
                    <div class="payment-summary">
                        <div class="summary-row">
                            <span>Subtotal:</span>
                            <span>${currency}${Utils.formatAmount(lineItem?.subTotal)}</span>
                        </div>
                        <div class="summary-row">
                            <span>Advanced Payment:</span>
                            <span>-${currency}${Utils.formatAmount(lineItem?.advPayment)}</span>
                        </div>
                        <div class="summary-row">
                            <span>Tax:</span>
                            <span>+${currency}${Utils.formatAmount(lineItem?.tax)}</span>
                        </div>
                        <div class="summary-row">
                            <span>Store Discount:</span>
                            <span>-${currency}${Utils.formatAmount(lineItem?.storeDisc)}</span>
                        </div>
                        <div class="summary-row">
                            <span>Other Charges: ${(lineItem?.chargeNotes)}</span>
                            <span>+${currency}${Utils.formatAmount(lineItem?.othCharges)}</span>
                        </div>
                        <div class="summary-row">
                            <span>Tips:</span>
                            <span>+${currency}${Utils.formatAmount(lineItem?.serviceTip)}</span>
                        </div>
                        <div class="summary-row total">
                            <span>Total Paid:</span>
                            <span>${currency}${Utils.formatAmount(lineItem?.total)}</span>
                        </div>
                    </div>
                </div>
                
                <div class="footer">
                    <p>Thank you for choosing Petsked!</p>
                    <p>For any queries, please contact us at support@petsked.com</p>
                </div>
            </div>
            
            <script>
                window.onload = function() {
                    setTimeout(function() {
                        window.print();
                    }, 500);
                };
            </script>
        </body>
        </html>
      `;

      // Open new window with the populated template
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        printWindow.document.write(template);
        printWindow.document.close();
      }
    } catch (error) {
      console.error('Error generating receipt:', error);
      showNotification({ type: 'error', title: 'Failed to generate receipt' });
    }
  };
  const getContent = () => {
    const servicePrice = parseFloat(selectedAppointment.servicePrice);
    const petData = selectedAppointment.pet
      ? [selectedAppointment.pet]
      : selectedAppointment.pets && selectedAppointment.pets.length > 0
        ? selectedAppointment.pets
        : [];
    let singlePet = undefined;
    if (!selectedAppointment.accomodationType && petData?.length) {
      singlePet = petData[0];
    }
    return !showCashPayment ? (
      <>
        <div className="payment-details">
          <div className="payment-detail-profile-block">
            {!selectedAppointment.accomodationType && singlePet && singlePet.name && (
              <div className="pay-profile">
                <div className="pay-pic-block pay-pic-block-57">
                  <img
                    className="pay-pic"
                    src={
                      singlePet?.petsImageUrl
                        ? singlePet?.petsImageUrl
                        : singlePet?.petType?.toLowerCase() == 'cat'
                          ? PetCat
                          : PetsIcon
                    }
                  />
                </div>
                <div className="pay-info-block">
                  <div className="pay-name">{singlePet?.name}</div>
                  <div className="pay-email">
                    {singlePet?.breed ? `Breed: ${singlePet?.breed}` : ''}
                  </div>
                </div>
              </div>
            )}
            {selectedAppointment.accomodationType && (
              <BoardingPetInfo
                data={petData}
                accomodationType={selectedAppointment?.accomodationType}
              />
            )}
            <div className="icon-profile">
              <div className="icon-pic-block">
                <img className="icon-pic" src={CardIcon} />
              </div>
              <div className="icon-info-block">
                <div className="icon-name">{selectedAppointment?.petParent?.name}</div>
                <div className="icon-email">
                  <span className="mail-text">{selectedAppointment?.petParent?.email}</span>
                  <span className="line-left">
                    {selectedAppointment?.petParent?.phone
                      ? Utils.formatPhoneNumber(selectedAppointment?.petParent?.phone)
                      : ''}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="more-detail-block">
            <div className="service-row">
              {selectedAppointment.room ? (
                <div className="service-name">{selectedAppointment?.room?.name} </div>
              ) : (
                <div className="service-name">
                  {selectedAppointment?.referenceBookingId
                    ? selectedAppointment?.summary
                    : selectedAppointment?.service?.name}{' '}
                  {selectedAppointment?.addonServices &&
                    selectedAppointment?.addonServices?.length > 0 && (
                      <span className="addons-service-count" style={{ cursor: 'pointer' }}>
                        +{selectedAppointment?.addonServices?.length}
                      </span>
                    )}
                </div>
              )}
              <div className="service-name">
                {currency}
                {selectedAppointment.room
                  ? formatValue({
                    value:
                      '' +
                      Number(
                        selectedAppointment.bookingFee ? selectedAppointment.bookingFee : 0
                      ).toFixed(2),
                    groupSeparator: ',',
                    decimalSeparator: '.',
                    prefix: '',
                  })
                  : formatValue({
                    value:
                      '' +
                      Number(
                        selectedAppointment.servicePrice ? selectedAppointment.servicePrice : 0
                      ).toFixed(2),
                    groupSeparator: ',',
                    decimalSeparator: '.',
                    prefix: '',
                  })}
              </div>
            </div>
            <div className="service-row desc-row">
              <div className={`service-desc ${showMore ? 'show-more' : ''}`}>
                {selectedAppointment?.referenceBookingId
                  ? selectedAppointment?.summary
                  : selectedAppointment?.room
                    ? selectedAppointment?.room?.description
                    : selectedAppointment?.service?.description}
              </div>
              {(selectedAppointment.accomodationType === 'grooming' ||
                selectedAppointment.accomodationType === 'daycare') && (
                  <div className="service-desc">
                    {selectedAppointment?.duration
                      ? Utils.getDuration(selectedAppointment?.duration)
                      : 0}
                  </div>
                )}
              {selectedAppointment.accomodationType === 'boarding' && (
                <div className="service-desc">
                  {selectedAppointment.duration && selectedAppointment.duration > 1
                    ? selectedAppointment.duration + ' Days'
                    : selectedAppointment.duration + ' Day'}
                </div>
              )}
            </div>
            {showMore && (
              <>
                {selectedAppointment.accomodationType === 'boarding' ? (
                  <>
                    <div className="duration-row">
                      <div className="duration-txt">Date & duration</div>
                      <div className="duration-date">
                        {Utils.formatDateStringTz(
                          selectedAppointment?.startTime,
                          user?.activeLocation?.timezone,
                          'ddd, DD MMM, yyyy'
                        )}
                      </div>
                      <div className="duration-time">
                        {Utils.formatDateStringTz(
                          selectedAppointment?.startTime,
                          user?.activeLocation?.timezone,
                          'hh:mm A'
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="duration-row">
                    <div className="duration-txt">{t('Date & duration')}</div>
                    <div className="duration-date">
                      {Utils.formatDateStringTz(
                        selectedAppointment?.startTime,
                        user?.activeLocation?.timezone,
                        'ddd, DD MMM, yyyy'
                      )}
                    </div>
                    <div className="duration-time">
                      {Utils.formatDateStringTz(
                        selectedAppointment?.startTime,
                        user?.activeLocation?.timezone,
                        'hh:mm A'
                      )}
                      <span>
                        {' '}
                        (
                        {Utils.getDuration(
                          selectedAppointment.duration || selectedAppointment?.service?.duration
                        )}
                        )
                      </span>
                    </div>
                  </div>
                )}
                {/* <hr /> */}
                {selectedAppointment.accomodationType && selectedAppointment?.pets && (
                  <div className="pet-list-display">
                    {selectedAppointment?.pets.map((pet, index) => (
                      <PetConfirmationDisplay data={pet} showPrice={true} currency={currency} />
                    ))}
                  </div>
                )}
                {!selectedAppointment.room && (
                  <>
                    <div className="duration-row second-row">
                      <div className="duration-txt">{t('Service provider')}</div>
                      <div className="pay-profile padding-13">
                        <div className="pay-pic-block">
                          <img
                            className="pay-pic"
                            src={
                              selectedAppointment?.businessUser?.avatarUrl
                                ? selectedAppointment?.businessUser?.avatarUrl
                                : petimg
                            }
                          />
                        </div>
                        <div className="pay-info-block">
                          <div className="pay-name">{selectedAppointment?.businessUser?.name}</div>
                          <div className="pay-email">{selectedAppointment?.businessUser?.email}</div>
                        </div>
                      </div>
                    </div>
                    {selectedAppointment.additionalGroomers && selectedAppointment.additionalGroomers.length > 0 && (
                      <div className="duration-row second-row">
                        <div className="duration-txt">{t('Assistant Groomers')}</div>
                        <div className="pay-profile-container padding-13">
                          {selectedAppointment.additionalGroomers.map((groomer, index) => (
                            <div className='pay-profile mb-3' key={`additional-${index}`}>
                              <div className="pay-pic-block">
                                <img
                                  className="pay-pic"
                                  src={
                                    groomer?.avatar_url
                                      ? groomer?.avatar_url
                                      : petimg
                                  }
                                />
                              </div>
                              <div className="pay-info-block">
                                <div className="pay-name">{groomer?.firstName || ''} {groomer?.lastName || ''}</div>
                                <div className="pay-email">{groomer?.email}</div>
                              </div>
                            </div>))}
                        </div>
                      </div>)}
                  </>
                )}
                {!selectedAppointment.room &&
                  selectedAppointment?.addonServices &&
                  selectedAppointment?.addonServices.length > 0 && (
                    <div className="duration-row addons">
                      <div className="duration-txt">{t('Add-on services')}</div>
                      <div className="duration-date">
                        <ul className="addon-services">
                          {selectedAppointment.addonServices.map((addonService) => (
                            <li>{addonService.name}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
              </>
            )}
            {!showCashPayment && (
              <div className="more-detail-row">
                <div
                  className="more-detail-text"
                  onClick={() => {
                    setShowMore(!showMore);
                  }}
                >
                  {showMore ? t('- Less details') : t('+ More details')}
                </div>
              </div>
            )}
          </div>
          <div className="payment-detail-block">
            {!selectedAppointment.room &&
              selectedAppointment?.addonServices &&
              selectedAppointment?.addonServices.length > 0 && (
                <div className="total-pay-row-amt mt-10">
                  <div className="left-label">
                    <div className="amount-tax">{t('Add-on Services')}</div>
                    <div className="dah-line"></div>
                  </div>
                  <div className="amount-dark">
                    {currency}
                    {formatValue({
                      value:
                        '' +
                        Number(
                          selectedAppointment.addonPrice ? selectedAppointment.addonPrice : 0
                        ).toFixed(2),
                      groupSeparator: ',',
                      decimalSeparator: '.',
                      prefix: '',
                    })}
                  </div>
                </div>
              )}
            <div className="total-pay-row-amt mt-4">
              <div className="left-label">
                <div className="amount-tax">{t('Subtotal')}</div>
                <div className="dah-line"></div>
              </div>
              <div className="amount-dark">
                {currency}
                {Utils.formatAmount(lineItem?.subTotal)}
              </div>
            </div>

            <div className="total-pay-row-amt">
              <div className="left-label">
                <div className="amount-tax advance-amouht-width">{t('Advanced payment')}</div>
                <div className="dah-line"></div>
              </div>
              <div className="amount-light">
                -{currency}
                {Utils.formatAmount(lineItem?.advPayment)}
              </div>
            </div>
            {servicePrice > 0 && (
              <div className="total-pay-row-amt">
                <div className="left-label">
                  <div className="amount-tax store-amouht-width">
                    <div className="optional">{t('Tax')}</div>{' '}
                    <div>
                      {paymentStatus === 'Request payment' && (
                        <div
                          className="edit-other-amt"
                          onClick={() => {
                            setTax(true);
                            setTimeout(() => {
                              Utils.scrollElementToView('discount-edit');
                            }, 250);
                          }}
                        >
                          <EditIcon />
                          {t('add')}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="dah-line"></div>
                </div>
                <div className="amount-light">
                  +{currency}
                  {Utils.formatAmount(lineItem?.tax)}
                </div>
              </div>
            )}
            {tax && (
              <div className="total-pay-row-amt no-border">
                <div className="edit-price-div">
                  <div className="other-charges-divider"></div>
                  <div className="other-changes-text-div">
                    <div className="other-changes-text-div">{'Add tax'}</div>
                    <div
                      className="other-changes-text-div pink-clr"
                      onClick={() => {
                        setTax(false);
                        setTaxAmount(texAmount);
                      }}
                    >
                      {t('- Cancel')}
                    </div>
                  </div>
                  <div className="edit-price-block discount-edit input-prifix-text">
                    <div className="relative rounded-md">
                      <div className="pointer-events-none absolute input-prifix">
                        <span className="text-gray-500 sm:text-sm usd-text-font">{currency} </span>
                        <span className="text-gray-500 sm:text-sm edit-price-line"> |</span>
                      </div>
                      <input
                        type="text"
                        name="discount"
                        id="discount"
                        className="new-cust-input adding-padding"
                        placeholder={t('Enter price')}
                        onChange={(e: any) => {
                          setNewTaxAmount(e.target.value);
                        }}
                        value={newTaxAmount}
                        maxLength={8}
                      />
                    </div>
                    <Button
                      variant="inverse"
                      size="sm"
                      onClick={applyTax}
                      className="apply-btn"
                      disabled={updateAppointmentMutation.isLoading}
                    >
                      {updateAppointmentMutation.isLoading ? t('Applying') : t('Apply')}
                    </Button>
                  </div>
                </div>
              </div>
            )}

            {servicePrice > 0 && (
              <div className="total-pay-row-amt">
                <div className="left-label">
                  <div className="amount-tax store-amouht-width">
                    <div className="optional">{t('Store discount (optional)')}</div>{' '}
                    <div>
                      {paymentStatus === 'Request payment' && (
                        <div
                          className="edit-other-amt"
                          onClick={() => {
                            setEditDiscount(true);
                            setTimeout(() => {
                              Utils.scrollElementToView('discount-edit');
                            }, 250);
                          }}
                        >
                          <EditIcon />
                          {t('add')}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="dah-line"></div>
                </div>
                <div className="amount-light">
                  -{currency}
                  {Utils.formatAmount(lineItem?.storeDisc)}
                </div>
              </div>
            )}
            {editDiscount && (
              <div className="total-pay-row-amt no-border">
                <div className="edit-price-div">
                  <div className="other-charges-divider"></div>
                  <div className="other-changes-text-div">
                    <div className="other-changes-text-div">{'Add store discount'}</div>
                    <div
                      className="other-changes-text-div pink-clr"
                      onClick={() => {
                        setEditDiscount(false);
                        setStoreDiscount(storeDiscount);
                      }}
                    >
                      {t('- Cancel')}
                    </div>
                  </div>
                  <div className="edit-price-block discount-edit input-prifix-text">
                    <div className="relative rounded-md">
                      <div className="pointer-events-none absolute input-prifix">
                        <span className="text-gray-500 sm:text-sm usd-text-font">{currency} </span>
                        <span className="text-gray-500 sm:text-sm edit-price-line"> |</span>
                      </div>
                      <input
                        type="text"
                        name="discount"
                        id="discount"
                        className="new-cust-input adding-padding"
                        placeholder={t('Enter price')}
                        onChange={(e: any) => {
                          setNewStoreDiscount(e.target.value);
                        }}
                        value={newStoreDiscount}
                        maxLength={8}
                      />
                    </div>
                    <Button
                      variant="inverse"
                      size="sm"
                      onClick={applyStoreDiscount}
                      className="apply-btn"
                      disabled={updateAppointmentMutation.isLoading}
                    >
                      {updateAppointmentMutation.isLoading ? t('Applying') : t('Apply')}
                    </Button>
                  </div>
                </div>
              </div>
            )}

            {servicePrice >= 0 && (
              <div className="total-pay-row-amt">
                <div className="left-label">
                  <div className="amount-tax other-amouht-width">
                    <div className="optional">
                      {lineItem?.chargeNotes ? lineItem.chargeNotes : t('Other charges')}
                    </div>{' '}
                    <div>
                      {paymentStatus.toLowerCase() ===
                        PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase() && (
                          <div
                            className="edit-other-amt"
                            onClick={() => {
                              setEditOtherCharges(true);
                              setTimeout(() => {
                                Utils.scrollElementToView('other-charges-edit');
                              }, 250);
                            }}
                          >
                            <EditIcon />
                            {t('add')}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="dah-line"></div>
                </div>
                <div className="amount-light">
                  +{currency}
                  {Utils.formatAmount(lineItem?.othCharges)}
                </div>
              </div>
            )}
            {editOtherCharges && (
              <div className="total-pay-row-amt no-border">
                <div className="edit-price-div">
                  <div className="other-charges-divider"></div>
                  <div className="other-changes-text-div">
                    <div className="other-changes-text-div">{t('Add other charges')}</div>
                    <div
                      className="other-changes-text-div pink-clr"
                      onClick={() => {
                        setEditOtherCharges(false);
                        setNewOtherCharges(otherCharges);
                      }}
                    >
                      {t('- Cancel')}
                    </div>
                  </div>
                  <div className="edit-price-block other-charges-edit input-prifix-text">
                    <div className="relative rounded-md">
                      <div className="pointer-events-none absolute input-prifix">
                        <span className="text-gray-500 sm:text-sm usd-text-font">{currency} </span>
                        <span className="text-gray-500 sm:text-sm edit-price-line"> |</span>
                      </div>
                      <input
                        type="text"
                        name="price"
                        id="price"
                        className="new-cust-input adding-padding"
                        placeholder={t('Enter price')}
                        onChange={(e: any) => {
                          setNewOtherCharges(e.target.value);
                        }}
                        value={newOtherCharges}
                        maxLength={8}
                      />
                    </div>
                    <input
                      type="text"
                      name="notes"
                      id="notes"
                      className="new-cust-input w-50 pl-4"
                      placeholder={t('Add note')}
                      onChange={(e: any) => {
                        setOtherChargesNote(e.target.value);
                      }}
                      value={otherChargesNote}
                    />
                    <Button
                      variant="inverse"
                      size="sm"
                      onClick={applyOtherCharges}
                      className="apply-btn"
                      disabled={updateAppointmentMutation.isLoading}
                    >
                      {updateAppointmentMutation.isLoading ? t('Applying') : t('Apply')}
                    </Button>
                  </div>
                </div>
              </div>
            )}
            {servicePrice >= 0 && !selectedAppointment.accomodationType && (
              <div className="total-pay-row-amt">
                <div className="left-label">
                  <div className="amount-tax other-amouht-width">
                    <div className="optional">Tips (optional)</div>{' '}
                    <div>
                      {paymentStatus.toLowerCase() ===
                        PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase() && (
                          <div
                            className="edit-other-amt"
                            onClick={() => {
                              setEditTippingCharges(true);
                              setTimeout(() => {
                                Utils.scrollElementToView('cards-tipping');
                              }, 250);
                            }}
                          >
                            <EditIcon />
                            add
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="dah-line"></div>
                </div>
                <div className="amount-light">
                  +{currency}
                  {Utils.formatAmount(lineItem?.serviceTip)}
                </div>
              </div>
            )}
            {editTippingCharges && (
              <div className="total-pay-row-amt no-border">
                <div className="edit-price-div">
                  <div className="other-charges-divider"></div>
                  <div className="other-changes-text-div">
                    <div className="other-changes-text-div">Add additional tip</div>
                    <div
                      className="other-changes-text-div pink-clr"
                      onClick={() => {
                        setEditTippingCharges(false);
                        setTippingCharges(otherCharges);
                      }}
                    >
                      - Cancel
                    </div>
                  </div>

                  <div className="edit-price-block input-prifix-text mt-3">
                    <div className="relative rounded-md">
                      <div className="pointer-events-none absolute input-prifix">
                        <span className="text-gray-500 sm:text-sm usd-text-font">{currency} </span>
                        <span className="text-gray-500 sm:text-sm edit-price-line"> | </span>
                      </div>
                      <input
                        type="text"
                        name="tips"
                        id="tips"
                        className="new-cust-input adding-padding"
                        placeholder="Enter tips"
                        onChange={(e: any) => {
                          setTippingCharges(e.target.value);
                        }}
                        value={tippingCharges}
                        maxLength={8}
                      />
                    </div>
                    <Button
                      variant="inverse"
                      size="sm"
                      onClick={applyTippingCharges}
                      className="apply-btn"
                      disabled={updateAppointmentMutation.isLoading}
                    >
                      {updateAppointmentMutation.isLoading ? 'Applying' : 'Apply'}
                    </Button>
                  </div>
                  <div className="cards-tipping">
                    <div
                      className={`tipping-card ${tippingCharges === '1' ? 'selected' : ''}`}
                      onClick={() => setTippingCharges('1')}
                    >
                      {currency} 1
                    </div>
                    <div
                      className={`tipping-card ${tippingCharges === '2' ? 'selected' : ''}`}
                      onClick={() => setTippingCharges('2')}
                    >
                      {currency} 2
                    </div>
                    <div
                      className={`tipping-card ${tippingCharges === '5' ? 'selected' : ''}`}
                      onClick={() => setTippingCharges('5')}
                    >
                      {currency} 5
                    </div>
                    <div
                      className={`tipping-card ${tippingCharges === '10' ? 'selected' : ''}`}
                      onClick={() => setTippingCharges('10')}
                    >
                      {currency} 10
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="total-pay-row">
              {selectedAppointment?.referenceBookingId && selectedAppointment.isComplete ? (
                <div className="total-text">{t('Total paid')}</div>
              ) : (
                <div className="total-text">
                  {paymentStatus.toLowerCase() === PAYMENT_STATUS.REFUND_PAYMENT.toLowerCase()
                    ? t('Refund Amount')
                    : paymentStatus.toLowerCase() === PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase()
                      ? t('Total payable')
                      : t('Total paid')}
                </div>
              )}
              <div className="total-text total-amounnt">
                {' '}
                {currency}
                {Utils.formatAmount(lineItem?.total)}
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      <div className="make-payment-details">
        {user?.activeLocation?.isSquareAccountVerified ? (
          <MakePaymentSquare
            onMakePayment={updateAppointmentPayment}
            onError={(err) => {
              showNotification({ type: 'error', title: err.message });
            }}
            locationId={user?.activeLocation?.squareLocationId || ''}
            businessLocationId={user?.activeLocationId}
            totalAmount={lineItem?.total}
            appointment={selectedAppointment}
            onBackClick={backToPaymentRequest}
            paymentDetails={paymentDetails}
            onChange={onPaymentDetailsChange}
            isLoading={requestPaymentMutation.isLoading}
          />
        ) : (
          <Elements stripe={stripePromise}>
            <MakePaymentStripe
              totalAmount={lineItem?.total}
              appointment={selectedAppointment}
              onMakePayment={updateAppointmentPayment}
              onBackClick={backToPaymentRequest}
              paymentDetails={paymentDetails}
              onChange={onPaymentDetailsChange}
              isLoading={requestPaymentMutation.isLoading}
            />
          </Elements>
        )}
      </div>
    );
  };
  const getAction = () => {
    const servicePrice = parseFloat(
      selectedAppointment.room
        ? selectedAppointment.bookingFee.toString()
        : selectedAppointment.servicePrice
    );
    return servicePrice > 0 || (servicePrice === 0 && lineItem?.total ? parseFloat(lineItem.total.toString()) : 0) > 0 ? (
      showCashPayment ? (
        <> </>
      ) : (
        <>
          <Button
            size="lg"
            variant="inverse"
            className="full"
            onClick={onCashPaymentClick}
            disabled={
              requestPaymentMutation.isLoading ||
              editDiscount ||
              editOtherCharges ||
              (paymentStatus.toLowerCase() !== PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase() &&
                paymentStatus.toLowerCase() !== PAYMENT_STATUS.REFUND_PAYMENT.toLowerCase()) ||
              (selectedAppointment?.isComplete ? true : false)
            }
          >
            {t('Make Payment')}
          </Button>
          {selectedAppointment.resendPaymentLink ? (
            <div className="payment-actions">
              <Button
                variant="primary"
                size="lg"
                className="full m-0"
                onClick={() => updateAppointmentPayment(undefined, true)}
                disabled={requestPaymentMutation.isLoading || editDiscount || editOtherCharges}
              >
                {t('Resend Payment Request')}
              </Button>
              {selectedAppointment.paymentLink && (
                <div className="share-link">
                  <div className="link-copy">
                    {isCopyLocation ? (
                      <>
                        {' '}
                        <div className="copy-msg">Link copied!</div>
                        <button
                          type="button"
                          className="copy-sucess"
                          onClick={() => {
                            if (selectedAppointment.paymentLink) {
                              navigator.clipboard.writeText(selectedAppointment.paymentLink);
                              setIsCopyLocation(true);
                            }
                          }}
                        >
                          <LinkCopy />
                        </button>
                      </>
                    ) : (
                      <button
                        type="button"
                        className="refresh-btn-new copy"
                        title="Copy URL"
                        onClick={() => {
                          if (selectedAppointment.paymentLink) {
                            navigator.clipboard.writeText(selectedAppointment.paymentLink);
                            setIsCopyLocation(true);
                            if (timer) {
                              clearTimeout(timer);
                            }
                            timer = setTimeout(() => {
                              setIsCopyLocation(false);
                            }, 2000);
                          }
                        }}
                      >
                        <CopyIconStyle />
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          ) : (
                <>
                  <Button
                    variant="primary"
                    size="lg"
                    className="full"
                    onClick={() => updateAppointmentPayment(undefined, true)}
                    disabled={
                      requestPaymentMutation.isLoading ||
                      editDiscount ||
                      editOtherCharges ||
                      (paymentStatus.toLowerCase() !== PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase() &&
                        paymentStatus.toLowerCase() !== PAYMENT_STATUS.REFUND_PAYMENT.toLowerCase()) ||
                      (selectedAppointment?.isComplete ? true : false)
                    }
                  >
                    {selectedAppointment?.isComplete ? t('Payment Completed') : paymentStatus}
                  </Button>
                  {selectedAppointment?.isComplete && (
                    <Button
                      variant="inverse"
                      size="lg"
                      className="full mt-20"
                      onClick={downloadPDF}
                    >
                      {t('Print Receipt')}
                    </Button>
                  )} 
                </>
          )}
        </>
      )
    ) : (
      <></>
    );
  };
  return userContext && userContext.isLandscape ? (
    <>
      <Modal
        show={open}
        onHide={() => onClose(reloadEvents)}
        className="petsked-modal-dialog payment-modal"
      >
        <Modal.Header closeButton>
          <Heading
            size="lg"
            title={showCashPayment ? t('Make Payment') : t('Payment Request')}
            description={
              showCashPayment
                ? t('Select the payment option you are receiving')
                : paymentStatus.toLowerCase() === PAYMENT_STATUS.PAYMENT_COMPLETED.toLowerCase()
                  ? t('Payment Done')
                  : t('Make or request the payment to the details below')
            }
          />
        </Modal.Header>

        <Modal.Body>{getContent()}</Modal.Body>
        <Modal.Footer>{getAction()}</Modal.Footer>
      </Modal>
    </>
  ) : (
    <div className={`payment-details-mobile ${isMap ? 'add-margin-top' : ''}`}>
      <div
        className="menu-back-nav"
        onClick={() => {
          onClose(reloadEvents);
        }}
      >
        <MenuBackIcon /> <span>{t('Back')}</span>
      </div>
      <Heading
        size="lg"
        title={showCashPayment ? t('Make Payment') : t('Payment Request')}
        description={
          showCashPayment
            ? t('Select the payment option you are receiving')
            : paymentStatus.toLowerCase() === PAYMENT_STATUS.PAYMENT_COMPLETED.toLowerCase()
              ? t('Payment Done')
              : t('Make or request the payment to the details below')
        }
      />{' '}
      {getContent()}
        <div className="action">
          {getAction()}
          {/* {selectedAppointment?.isComplete && !showCashPayment && (
            <Button
              variant="inverse"
              size="lg"
              className="full mt-2"
              onClick={downloadPDF}
            >
              {t('Print Receipt')}
            </Button>
          )} */}
        </div>
    </div>
  );
};

export default PaymentRequest;
